module.exports = __webpack_public_path__ + "img/Damp 2.jpg";